import styles from './FecharPedido.module.css'
import { useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import PedidosContext from '../../../shared/contexts/PedidosContext'
import { useNavigate } from 'react-router-dom';


function FecharPedido({forma_de_pagamento, total}) {
    const [showModal, setShowModal] = useState(false);
    const {atualizarPedidos} = useContext(PedidosContext)
    const navigate = useNavigate();

    // Cliente não logado tentando finalizar o pedido: manda pro login/cadastro
    // e guarda o caminho de volta pro carrinho pra continuar de onde parou.
    const irParaLoginOuCadastro = () => {
        localStorage.setItem('redirect_after_login', '/carrinhodeitens');
        alert("Você ainda não está logado. Faça login ou crie uma conta para finalizar o pedido.");
        navigate('/home');
    };

    const verificarEstabelecimentoAberto = async () => {
        const estabelecimento_id = localStorage.getItem("estabelecimento_id");
        const API_URL = process.env.REACT_APP_API_URL;

        try {
            const response = await fetch(`${API_URL}/estabelecimentos`);
            const estabelecimentos = await response.json();
            const est = estabelecimentos.find(
                e => e.id_estabelecimento === Number(estabelecimento_id)
            );

            if (!est) {
                alert("Estabelecimento não encontrado.");
                return false;
            }

            // Se fechamento_manual está ativo, usa o campo status_aberto
            if (est.fechamento_manual === 1) {
                if (est.status_aberto !== 'aberto') {
                    alert("O estabelecimento está fechado no momento. Não é possível fazer pedidos.");
                    return false;
                }
                return true;
            }

            // Caso contrário, verifica pelo horário de funcionamento
            if (est.hora_abertura && est.hora_fechamento) {
                const agora = new Date();
                const horaAtual = agora.getHours().toString().padStart(2, '0') + ':' + agora.getMinutes().toString().padStart(2, '0');

                if (horaAtual < est.hora_abertura.substring(0, 5) || horaAtual >= est.hora_fechamento.substring(0, 5)) {
                    alert(`O estabelecimento só aceita pedidos das ${est.hora_abertura.substring(0, 5)} às ${est.hora_fechamento.substring(0, 5)}.`);
                    return false;
                }
            }

            return true;
        } catch (error) {
            console.error("Erro ao verificar status do estabelecimento:", error);
            alert("Erro ao verificar se o estabelecimento está aberto. Tente novamente.");
            return false;
        }
    };


    // Pedido feito via QR code de mesa: sem cadastro de cliente, exceto em
    // lanchonete universitária (mesa_exige_cadastro), onde o login continua
    // sendo pedido como hoje.
    const mesaAtiva = () => {
        const idMesaRaw = localStorage.getItem("id_mesa");
        const temMesa = idMesaRaw !== null && idMesaRaw !== "null" && idMesaRaw !== "";
        const temTokenQrCode = !!localStorage.getItem("mesa_token_qrcode");
        const exigeCadastro = localStorage.getItem("mesa_exige_cadastro") === 'true';
        return temMesa && temTokenQrCode && !exigeCadastro;
    };

    // Criar pedido sem pagamento (para testes, e também usado pelo fluxo de mesa/QR code)
    const criarPedidoSemPagamento = async () => {
        setShowModal(false);

        const tipo_entrega = localStorage.getItem("tipoEntrega");
        const data_agendada = localStorage.getItem("dataAgendada");
        const hora_agendada = localStorage.getItem("horaAgendada");
        const idMesaRaw = localStorage.getItem("id_mesa");
        const idMesa = idMesaRaw === null || idMesaRaw === "null" || idMesaRaw === "" ? null : Number(idMesaRaw);

        const estabelecimento_id = localStorage.getItem("estabelecimento_id");
        const id_cliente = localStorage.getItem("id_cliente");
        const pedidoDeMesaSemCadastro = mesaAtiva();

        if (!estabelecimento_id || estabelecimento_id === 'undefined' || estabelecimento_id === 'null') {
            alert("ID do estabelecimento não encontrado. Faça login novamente.");
            return;
        }

        if (!pedidoDeMesaSemCadastro && (!id_cliente || id_cliente === 'undefined' || id_cliente === 'null')) {
            irParaLoginOuCadastro();
            return;
        }

        const carrinhoAtual = JSON.parse(localStorage.getItem('carrinho')) || [];

        if (carrinhoAtual.length === 0) {
            alert("Seu carrinho está vazio!");
            return;
        }

        const pedido = {
            id_estabelecimento: Number(estabelecimento_id),
            id_cliente: (id_cliente && id_cliente !== 'undefined' && id_cliente !== 'null') ? Number(id_cliente) : null,
            forma_de_pagamento: forma_de_pagamento || 'A definir',
            total: total,
            id_mesa: idMesa,
            origem_pedido: pedidoDeMesaSemCadastro ? 'mesa_qrcode' : 'app',
            tipo_entrega: tipo_entrega,
            data_agendada: data_agendada || null,
            hora_agendada: hora_agendada || null,
            itens: carrinhoAtual.map(item => ({
                id_estabelecimento: Number(estabelecimento_id),
                id_produto: item.id_item,
                quantidade: item.quantidade || 1,
                total_item: item.total_item || parseFloat(item.preco) * (item.quantidade || 1),
                observacao: item.observacao || 'Sem observação',
                nome_item: item.label_title || item.nome_item || 'Produto'
            }))
        };

        try {
            const API_URL = process.env.REACT_APP_API_URL;
            const token = localStorage.getItem("token");

            const headers = { 'Content-Type': 'application/json' };
            if (token && token !== 'null' && token !== 'undefined') {
                headers.Authorization = `Bearer ${token}`;
            }

            console.log("🧪 [TESTE] Criando pedido sem pagamento...");
            const response = await fetch(`${API_URL}/fecharpedido`, {
                method: 'POST',
                headers,
                body: JSON.stringify(pedido),
            });

            const result = await response.json();
            console.log('✅ [TESTE] Pedido criado:', result);

            if (response.ok) {
            alert(
                result.codigo_entrega
                    ? `✅ Pedido criado com sucesso!\nCódigo de entrega: ${result.codigo_entrega}`
                    : `✅ Pedido criado com sucesso!`
            );
            localStorage.removeItem('carrinho');

            // Atualizar lista de pedidos no contexto
            //await atualizarPedidos();

            // Passando o pedido criado pelo state do navigate
            navigate('/sucesso', { state: { pedidoCriado: result } });

            } else {
                alert(`Erro ao criar pedido: ${result.message || 'Erro desconhecido'}`);
            }
        } catch (error) {
            console.error('❌ [TESTE] Erro ao criar pedido:', error);
            alert('Ocorreu um erro ao tentar criar o pedido. Tente novamente.');
        }
    };

    // Criar pedido com pagamento (Mercado Pago)
    const concluirPedidoComPagamento = async () => {
        setShowModal(false);

        const tipo_entrega = localStorage.getItem("tipoEntrega");
        const data_agendada = localStorage.getItem("dataAgendada");
        const hora_agendada = localStorage.getItem("horaAgendada");
        const idMesaRaw = localStorage.getItem("id_mesa");
        const idMesa = idMesaRaw === null || idMesaRaw === "null" || idMesaRaw === "" ? null : Number(idMesaRaw);

        const estabelecimento_id = localStorage.getItem("estabelecimento_id");
        const id_cliente = localStorage.getItem("id_cliente");

        if (!estabelecimento_id || estabelecimento_id === 'undefined' || estabelecimento_id === 'null') {
            alert("ID do estabelecimento não encontrado. Faça login novamente.");
            return;
        }

        if (!id_cliente || id_cliente === 'undefined' || id_cliente === 'null') {
            irParaLoginOuCadastro();
            return;
        }

        const carrinhoAtual = JSON.parse(localStorage.getItem('carrinho')) || [];

        if (carrinhoAtual.length === 0) {
            alert("Seu carrinho está vazio!");
            return;
        }

        const pedido = {
            id_estabelecimento: Number(estabelecimento_id),
            id_cliente: Number(id_cliente),
            forma_de_pagamento: forma_de_pagamento || 'A definir',
            total: total,
            id_mesa: idMesa,
            tipo_entrega: tipo_entrega,
            data_agendada: data_agendada || null,
            hora_agendada: hora_agendada || null,
            itens: carrinhoAtual.map(item => ({
                id_estabelecimento: Number(estabelecimento_id),
                id_produto: item.id_item,
                quantidade: item.quantidade || 1,
                total_item: item.total_item || parseFloat(item.preco) * (item.quantidade || 1),
                observacao: item.observacao || 'Sem observação',
                nome_item: item.label_title || item.nome_item || 'Produto'
            }))
        };


        try {
            const API_URL = process.env.REACT_APP_API_URL;
            const token = localStorage.getItem("token");

            console.log("💳 [PAGAMENTO] Criando pagamento no Mercado Pago...");
            const response = await fetch(`${API_URL}/criar-pagamento-mp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(pedido),
            });

            const result = await response.json();
            console.log('Resposta do servidor:', result);

            if (response.ok && result.init_point) {
                localStorage.setItem('payment_reference', result.reference);
                const checkoutURL = result.init_point || result.sandbox_init_point;
                console.log('Redirecionando para Mercado Pago:', checkoutURL);
                window.location.href = checkoutURL;
            } else {
                alert(`Erro ao criar sessão de pagamento: ${result.message || 'Erro desconhecido'}`);
            }
        } catch (error) {
            console.error('❌ [PAGAMENTO] Erro ao criar pagamento:', error);
            alert('Ocorreu um erro ao tentar criar o pagamento. Tente novamente.');
        }
    };


    return (
        <div className="fechar-pedido-container">
            <button
                className={styles.fechar_pedido_btn}
                onClick={async () => {
                    if (!forma_de_pagamento) {
                        alert("Selecione uma forma de pagamento antes de fechar o pedido.");
                        return;
                    }
                    const aberto = await verificarEstabelecimentoAberto();
                    if (aberto) setShowModal(true);
                }}
            >
                Fechar Pedido
            </button>

            {/* Modal de confirmação via Portal (renderiza no body) */}
            {showModal && createPortal(
                <div className={styles.modalOverlay} onClick={() => setShowModal(false)}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <h2>Confirmar Pedido</h2>
                        <p>Forma de pagamento: <strong>{forma_de_pagamento}</strong></p>

                        <div className={styles.modalButtons}>
                            {(forma_de_pagamento === 'Dinheiro' || mesaAtiva()) ? (
                                <button
                                    className={styles.btnPagar}
                                    onClick={criarPedidoSemPagamento}
                                >
                                    Confirmar Pedido
                                </button>
                            ) : (
                                <>
                                    <button
                                        className={styles.btnTeste}
                                        onClick={criarPedidoSemPagamento}
                                    >
                                        Testar sem pagamento
                                    </button>

                                    <button
                                        className={styles.btnPagar}
                                        onClick={concluirPedidoComPagamento}
                                    >
                                        Pagar agora
                                    </button>
                                </>
                            )}
                        </div>

                        <button
                            className={styles.btnCancelar}
                            onClick={() => setShowModal(false)}
                        >
                            Cancelar
                        </button>
                    </div>
                </div>,
                document.body
            )}
        </div>
    );
}

export default FecharPedido;